import {React, observer, Fragment} from '@api';
import {useStores} from '@modules'
import { ProductPageHeader, } from './templates/vlp/VlpProductPage'
import {Page, StyleSheet, Text, View} from "@react-pdf/renderer";
import {Observer} from 'mobx-react';

const styles = StyleSheet.create({
  page:                  {
    flexDirection:   'column',
    backgroundColor: '#FFFFFF',
    display:         'flex',
  },
  specGlossaryContainer: {
    paddingLeft:   24,
    paddingRight:  24,
    paddingTop:    8,
    paddingBottom: 8
  },
  specTableOfContents:   {
    display:       'flex',
    flexDirection: 'column'
  }
});

export const PdfGlossary = ({products}) => {
  const {
      catalog: {catalogConfig: {fields}}, pdf: {selectedPdfDocument: {size, orientation}}
  } = useStores()

  return (<Fragment>
    {fields.filter(lt => lt.field != null).map(lt =>
      <Page key={lt.field} size={size} orientation={orientation} style={{...styles.page}}>
        <ProductPageHeader />
        <View style={styles.specGlossaryContainer}>
          <Text
            style={{
              textTransform:     'uppercase',
              fontWeight:        600,
              paddingLeft:       2,
              paddingBottom:     8,
              marginBottom:      28,
              fontSize:          16,
              borderBottomWidth: 1,
              borderBottomStyle: 'solid',
              borderBottomColor: 'black'
            }}>{lt.label} Glossary</Text>


          <Observer>{() => {
            const grouped = _.groupBy(products, p => p[lt.field] ? p[lt.field].id : null)
            //console.log(grouped, lt.value, productsTransformed)
            return <View style={{...styles.specTableOfContents}}>
              <View style={{display: 'flex', flexDirection: 'row', marginBottom: 8}}>
                <Text style={{width: 80, textTransform: 'uppercase'}}>CODE</Text>
                <Text style={{marginLeft: 20, flexGrow: 1, textTransform: 'uppercase'}}>Description</Text>
                <Text style={{marginLeft: 20, textTransform: 'uppercase'}}>Composition</Text>
              </View>

              {Object.keys(grouped).map(g => {
                const productsInGroup = grouped[g]
                const spec            = _.first(productsInGroup)[lt.field]
                //console.log(spec, productsInGroup)
                return <View key={g} style={{display: 'flex', flexDirection: 'row'}}>
                  <Text style={{width: 80}}>{spec.code}</Text>
                  <Text style={{marginLeft: 20, flexGrow: 1}}>{spec.title}</Text>
                  <Text style={{marginLeft: 20}}>{spec.title}</Text>
                </View>
              })}
            </View>
          }}</Observer>
        </View>
      </Page>)}
  </Fragment>)
}


// WEBPACK FOOTER //
// ./src/modules/pdf/PdfGlossary.tsx